/* eslint-disable */
// There is no reason to include hot-loader in production builds
// so instead we will simply create a function that returns the component
// instead of including the hot-loader package in our bundle

let hot

if (process.env.NODE_ENV === 'development') {
  hot = require('react-hot-loader').hot
} else {
  hot = function (_) {
    return function (component) {
      return component
    }
  }
}

module.exports = hot
